import CheckListCreator from 'pages/CheckListCreator';
import ChecklistEdit from 'pages/ChecklistEdit';
import CheckListTable from 'pages/CheckListTable';
import ChecklistTeacher from 'pages/ChecklistTeacher';
import ChecklistTeacherNew from 'pages/ChecklistTeacherNew';
import CheckListUpdate from 'pages/CheckListUpdate';
import ChecklistView from 'pages/ChecklistView';
import ClassRoomGroup from 'pages/ClassRoomGroup';
import ClassRoomList from 'pages/ClassRoomList';
import CreateHomework from 'pages/CreateHomework';
import ExamCreator from 'pages/ExamCreator';
import ExamEdit from 'pages/ExamEdit';
import ExamTable from 'pages/ExamTable';
import ExamTeacher from 'pages/ExamTeacher';
import ExamTeacherNew from 'pages/ExamTeacherNew';
import ExamUpdate from 'pages/ExamUpdate';
import ExamView from 'pages/ExamView';
import GroupsList from 'pages/GroupsList';
import Home from 'pages/Home';
import HomeworkCreator from 'pages/HomeworkCreator';
import HomeworkTable from 'pages/HomeworkTable';
import HomeworkTeacher from 'pages/HomeworkTeacher';
import HomeworkUpdate from 'pages/HomeworkUpdate';
import Materials from 'pages/Materials';
import MaterialView from 'pages/MaterialView';
import NewNotebook from 'pages/NewNotebook';
import PublicMaterial from 'pages/PublicMaterial';
import QuillComponent from 'pages/QuillComponent';
import ScheduleEditor from 'pages/ScheduleEditor';
import Statistics from 'pages/Statistics';
import StudentHomeworkList from 'pages/StudentHomeworkList';
import StudentList from 'pages/StudentList';
import StudentsGroupView from 'pages/StudentsGroupView';
import StudentView from 'pages/StudentView';
import TeacherSchedule from 'pages/TeacherSchedule';
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

const Teacher = ({ user, userType }) => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/materials" element={<Materials mail={user.mail} />} />
      <Route path="/students" element={<StudentList mail={user.mail} />} />
      <Route path="/studentView/:id" element={<StudentView mail={user.mail} />} />
      <Route path="/notebook/:mail/:subject" element={<NewNotebook typeUser={userType} />} />
      <Route path="/materialView" element={<MaterialView mail={user.mail} />} />
      {/*<Route path="/examView" element={<ExamView />} />*/}
      <Route path="/createHomework" element={<CreateHomework mail={user.mail} />} />
      <Route path="/schedule/:id/subjects/:name" element={<ScheduleEditor mail={user.mail} />} />
      <Route path="/classroom/:id/:name" element={<ClassRoomList />} />
      <Route path="/schedule/:id" element={<TeacherSchedule mail={user.mail} />} />
      <Route path="/test" element={<QuillComponent />} />
      <Route path="/student-homework-list/:subject/:userMail" element={<StudentHomeworkList mail={user.mail} />} />
      <Route path="/checklist-teacher-new" element={<ChecklistTeacherNew mail={user.mail} />} />
      <Route path="/checklist-preview" element={<ChecklistTeacherNew mail={user.mail} preview />} />
      <Route path="/checklist-teacher/:checklistId" element={<ChecklistTeacher mail={user.mail} />} />
      <Route path="/checklist-view/:checklistId" element={<ChecklistView mail={user.mail} />} />
      <Route path="/checklist-edit/:id" element={<ChecklistEdit mail={user.mail} />} />

      <Route path="/exam-teacher-new" element={<ExamTeacherNew mail={user.mail} user={user} />} />
      <Route path="/exam-preview" element={<ExamTeacherNew mail={user.mail} preview />} />
      <Route path="/exam-teacher/:examId" element={<ExamTeacher mail={user.mail} />} />
      <Route path="/exam-view/:examId" element={<ExamView mail={user.mail} />} />
      <Route path="/exam-edit/:id" element={<ExamEdit mail={user.mail} />} />

      <Route path="/statistics" element={<Statistics />} />
      <Route path="/student-groups" element={<GroupsList mail={user.mail} />} />
      <Route path="/students-group-view/:id" element={<StudentsGroupView mail={user.mail} />} />
      <Route path="/classroomGroup/:id" element={<StudentsGroupView />} />
      <Route path="/classroomGroup/:id/:name" element={<ClassRoomGroup />} />
      <Route path="/materialView" element={<MaterialView />} />
      <Route path="/student-homework-list/:subject/:userMail" element={<StudentHomeworkList mail={user.mail} />} />
      <Route path="/checklist-view/:checklistId" element={<ChecklistView mail={user.mail} />} />

      <Route path="/checklist-create" element={<CheckListCreator />} />
      <Route path="/checklist-update" element={<CheckListUpdate />} />
      <Route path="/checklist-table" element={<CheckListTable mail={user.mail} />} />

      <Route path="/hw-create" element={<HomeworkCreator />} />
      <Route path="/hw-update" element={<HomeworkUpdate />} />
      <Route path="/hw-table" element={<HomeworkTable mail={user.mail} />} />
      <Route path="/hw-teacher" element={<HomeworkTeacher mail={user.mail} />} />
      <Route path="/hw-preview" element={<HomeworkTeacher mail={user.mail} preview />} />

      <Route path="/exam-view/:checklistId" element={<ExamView mail={user.mail} />} />

      <Route path="/exam-create" element={<ExamCreator />} />
      <Route path="/exam-update" element={<ExamUpdate />} />
      <Route path="/exam-table" element={<ExamTable mail={user.mail} />} />
      <Route path="/publicMaterial/:id" element={<PublicMaterial />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default Teacher;
